<template>
    <div class="switch-style">
        <img src="../assets/images/img/night.png" v-if="!isDay" @click="changeToWhite()">
        <img src="../assets/images/img/white.png" v-else @click="changeToBlack()">
    </div>
</template>
<script>
import { 
    STYLE_WHITE, 
    STYLE_BLACK 
} from '@/config/constants'
import display from '@/mixins/display.js'
export default {
    mixins: [display],
    methods: {
        changeToWhite () {
            this.$store.commit('changeStyle', STYLE_WHITE)
        },
        changeToBlack () {
            this.$store.commit('changeStyle', STYLE_BLACK)
        }
    }
}
</script>
<style lang="scss" scoped>
.switch-style{
    cursor:pointer;
    display: inline-block;
}
</style>
